import { useEffect, useState, useRef } from "react";
import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Send } from "@mui/icons-material";
import { MessagesAPI } from "../apis/messagesAPI";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const classes = {
 
  messagesBody: {
    height: '80vh',
    overflowY: "scroll",
    paddingTop: "2rem",
    border: "1px none black",
    width: "100%"
  },
  messageRow: {
    display: "flex",
    alignItems: "center",
    paddingLeft: "2rem",
    border: "1px none green",
  },
  messageRowRight: {
    display: "flex",
    paddingRight: "2rem",
    justifyContent: "flex-end",
    border: "1px none orange",
  },

  messageContent: {
    padding: "10px",
    margin: 0,
  },
  messageTimeStampRight: {
    
  },

  avatarNothing: {
    color: "transparent",
    backgroundColor: "transparent",
    // width: theme.spacing(4),
    // height: theme.spacing(4)
  },
  displayName: {
    border: "1px",
    display: "flex",
  },
};

const msgBlueStyle = {
  position: "relative",

  marginBottom: "10px",
  padding: "10px",
  backgroundColor: "#A8DDFD",
  textAlign: "left",
  font: "400 .9em 'Open Sans', sans-serif",
  border: "1px solid #97C6E3",
  borderRadius: "10px",
} as React.CSSProperties;

const msgOrangeStyle = {
  position: "relative",
  marginBottom: "10px",
  padding: "10px",
  backgroundColor: "#f8e896",
  width: "60%",

  textAlign: "left",
  font: "400 .9em 'Open Sans', sans-serif",
  border: "1px solid #dfd087",
  borderRadius: "10px",
} as React.CSSProperties;

type ChatContainerProps = {
  job: any;
  messages: any[];
};

const containerStyle = {

    height: "100%",
  display: "flex",
  position: "absolute",
  top: 0,
  bottom: 0,
  left: '30%',
  right: 0,
  alignItems: "center",
  justifyContent: "space-between",
  flexDirection: "column",
  border: "1px none red",
  marginBottom: '4rem',
} as React.CSSProperties;

const ChatContainer = ({ job, messages = [] }: ChatContainerProps) => {
  const messagesEndRef = useRef<null | HTMLDivElement>(null);
  const [msgs, setMsgs] = useState([] as any[]);
  const user = useSelector((state: any) => state.user || {});

  const [chatEndtime, setChatEndTime] = useState(dayjs("1/1/3000"));

  useEffect(() => {

    // TODO could set end time based on end date
    // if (job && job.events) {
    //   const endEvent = job.events.find((e: any) => {
    //     return endChatStatuses.indexOf(e.typeId) > -1
    //   });
    //   if (endEvent) {
    //     console.log('job events length', endEvent.created);
    //   }
    // }
    setChatEndTime(dayjs(job.endTime).add(3, 'day'));
  }, [job]);

  const onSend = async (msg: string) => {
    if (msg.length > 0) {
      try {
        const msgBody = {
          content: msg,
          jobId: job.id,
        };
        await MessagesAPI.send(msgBody);
        setCurrentMsg("");
      } catch (e) {
        console.log("error ", e);
      }
    }
  };

  const isChatEnded = (): boolean => {
    const currTime = dayjs(new Date());

    return chatEndtime.isBefore(currTime);
  }

  const onMsgChange = (msg: string) => {
    setCurrentMsg(msg);
  };

  useEffect(() => {
    setMsgs(messages);
  }, [messages]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [msgs]);

  const [currentMsg, setCurrentMsg] = useState("");
  return (
    <Box sx={containerStyle}>

        <Box id="style-1" sx={classes.messagesBody}>
          {msgs.map((m: any) => {
            if (user.id === m.authorId)
              return <MessageRight key={m.id} message={m.content} />;
            return <MessageLeft key={m.id} message={m.content} />;
          })}
          {isChatEnded() ? (<Typography style={{border: '1px none green', width: '100%', display: 'flex', justifyContent: 'center'}}variant="caption">Chat ended on {chatEndtime.format("MMMM D")}</Typography>) : null}
          
          <div ref={messagesEndRef} />
        </Box>

      <Box sx={{ border: "1px none", width: "100%", position: 'absolute', bottom: 0,  }}>
        <TextField
          value={currentMsg}
          onChange={(e) => onMsgChange(e.target.value)}
          disabled={isChatEnded()}
          onKeyDown={(ev) => {
            if (ev.key === "Enter") {
              onSend(currentMsg);
              ev.preventDefault();
            }
          }}
          sx={{
            width: '100%',
            
          }}
          slotProps={{
            htmlInput: {
                autocomplete: 'one-time-code',
            },
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    disabled={currentMsg.length === 0}
                    color={"primary"}
                    onClick={(e) => onSend(currentMsg)}
                  >
                    <Send />
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
        >
          {" "}
          <Send />
        </TextField>
      </Box>
    </Box>
  );
};

type MessageLeftProps = {
  message?: string;
};

const MessageLeft = ({ message }: MessageLeftProps) => {
  return (
    <>
      <div style={classes.messageRow}>
        <div>
          {/* <div style={classes.displayName}>{displayName}</div> */}
          <div style={msgBlueStyle}>
            <div>
              <p style={classes.messageContent}>{message}</p>
            </div>
            <div style={classes.messageTimeStampRight}></div>
          </div>
        </div>
      </div>
    </>
  );
};

const MessageRight = ({ message }: MessageLeftProps) => {
  return (
    <div style={classes.messageRowRight}>
      <div style={msgOrangeStyle}>
        <p style={classes.messageContent}>{message}</p>
        {/* <div style={classes.messageTimeStampRight}>{timestamp}</div> */}
      </div>
    </div>
  );
};

export default ChatContainer;
